import { Button } from "@/modern/components/ui/button";
import { Badge } from "@/modern/components/ui/badge";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/modern/components/ui/dropdown-menu";
import { Image, Video, FileText, Music, FolderOpen, ChevronDown } from "lucide-react";
import { useMyMediaContext, FileType } from "../context/MyMediaContext";

const fileTypeOptions: { value: FileType; label: string; icon: React.ReactNode }[] = [
  { value: "all", label: "All Files", icon: <FolderOpen className="h-4 w-4" /> },
  { value: "images", label: "Images", icon: <Image className="h-4 w-4" /> },
  { value: "videos", label: "Videos", icon: <Video className="h-4 w-4" /> },
  { value: "documents", label: "Documents", icon: <FileText className="h-4 w-4" /> },
  { value: "audio", label: "Audio", icon: <Music className="h-4 w-4" /> },
];

export const FileTypeFilter = () => {
  const { fileTypeFilter, setFileTypeFilter, fileTypeCounts } = useMyMediaContext();
  const currentOption = fileTypeOptions.find((opt) => opt.value === fileTypeFilter);
  const currentCount = fileTypeCounts[fileTypeFilter];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          {currentOption?.icon}
          <span>{currentOption?.label || "All Files"}</span>
          {currentCount > 0 && (
            <Badge
            size="xs"
            variant="secondary"
          >
            {currentCount}
          </Badge>
          )}
          <ChevronDown className="h-4 w-4 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {fileTypeOptions.map((option) => {
          const count = fileTypeCounts[option.value];
          const isActive = fileTypeFilter === option.value;

          return (
            <DropdownMenuItem
              key={option.value}
              onClick={() => setFileTypeFilter(option.value)}
              className={isActive ? "bg-accent" : ""}
            >
              <span>{option.icon}</span>
              {option.label}
              {count > 0 && (
                <Badge
                  size="xs"
                  variant="secondary"
                >
                  {count}
                </Badge>
              )}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
